import { render } from "./PerformanceTarget.vue?vue&type=template&id=01d50872"
import script from "./PerformanceTarget.vue?vue&type=script&lang=js"
export * from "./PerformanceTarget.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__